import React from 'react';
import PropTypes from 'prop-types';
import glamorous from 'glamorous';
import Avatar from '../../../../shared/library/avatars/avatar';
import {useSendAnalyticsEvent} from '../../../enhancers/analytics-enhancer';

const Conatiner = glamorous.div({
  display: 'block'
});

const AvatarContainer = glamorous.div({
  gridTemplateColumns: 'repeat(auto-fill, 64px)',
  justifyContent: 'space-between',
  gridGap: 20,
  display: 'grid',
  textAlign: 'center'
});

const FollowersCard = ({user, isMobile}) => {
  const sendAnalyticsEvent = useSendAnalyticsEvent();

  const {username, displayName} = user;
  return (
    <Conatiner>
      <AvatarContainer>
        <Avatar
          key={user.id}
          user={user}
          withPopover={!isMobile}
          onActivate={() => sendAnalyticsEvent('activate_teamMemberCard', {username, displayName})}
          onClick={() => sendAnalyticsEvent('click_teamMemberCard', {username, displayName})}
        />
      </AvatarContainer>
    </Conatiner>
  );
};

FollowersCard.propTypes = {
  user: PropTypes.object,
  isMobile: PropTypes.bool
};

export default FollowersCard;
